<template>
  <svg
    class="AtlasSpinner"
    width="70px"
    height="70px"
    viewBox="0 0 70 70"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      class="AtlasSpinner-path"
      fill="none"
      stroke-width="10"
      stroke-linecap="round"
      cx="35"
      cy="35"
      r="30"
    ></circle>
  </svg>
</template>

<script>
export default {
  name: 'atlas-spinner',
};
</script>

<style lang="scss">
// Adapted from https://codepen.io/mrrocks/pen/EiplA

$spinner-offset: 187;
$spinner-duration: 1.4s;

.AtlasSpinner {
  @include size(100%);
  animation: atlas-spinner-spin $spinner-duration linear infinite;

  &-path {
    animation: atlas-spinner-dash $spinner-duration ease-in-out infinite;
    stroke: color(primary);
    stroke-dasharray: $spinner-offset;
    stroke-dashoffset: 0;
    transform-origin: center;
  }
}

@keyframes atlas-spinner-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(270deg);
  }
}

@keyframes atlas-spinner-dash {
  0% {
    stroke-dashoffset: $spinner-offset;
  }

  50% {
    stroke-dashoffset: math.div($spinner-offset, 4);
    transform: rotate(135deg);
  }

  100% {
    stroke-dashoffset: $spinner-offset;
    transform: rotate(450deg);
  }
}
</style>
